<template>
  <div id="app">
    <EightQueue/>
  </div>
</template>

<script>
import EightQueue from './components/EightQueue.vue'

export default {
  name: 'App',
  components: {
    EightQueue
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
